import { Link } from 'react-router-dom';
import { Package, RefreshCw, TrendingUp, Grid, ArrowRight } from 'lucide-react';
import { useDashboard } from '../hooks';
import { useItems } from '../hooks';
import { StatCard, ItemCard, LoadingSpinner } from '../components';

export function Dashboard() {
  const { stats, loading: statsLoading } = useDashboard();
  const { items, loading: itemsLoading } = useItems();

  if (statsLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <LoadingSpinner size="lg" text="Loading dashboard..." />
      </div>
    );
  }

  return (
    <div className="space-y-12">
      {/* Stats Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard
          title="Total Items"
          value={stats?.total_items || 0}
          subtitle="In catalog"
          icon={Package}
          color="primary"
        />
        <StatCard
          title="Updated Today"
          value={stats?.updated_today || 0}
          subtitle="Items refreshed"
          icon={RefreshCw}
          color="success"
        />
        <StatCard
          title="Avg Confidence"
          value={`${Math.round((stats?.avg_confidence || 0) * 100)}%`}
          subtitle="Data quality"
          icon={TrendingUp}
          color="warning"
        />
        <StatCard
          title="Categories"
          value={stats?.total_categories || 0}
          subtitle="Item groups"
          icon={Grid}
          color="primary"
        />
      </div>

      {/* Recent Items */}
      <div>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Recent Items</h2>
          <Link
            to="/items"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1"
          >
            View all
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        {itemsLoading ? (
          <div className="flex items-center justify-center py-12">
            <LoadingSpinner text="Loading items..." />
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {items.slice(0, 6).map((item) => (
              <ItemCard key={item.id} item={item} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
